import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API = process.env.VUE_APP_API_URL;

export default {
  summary(params = {}) {
    return axios.get(`${API}reports/daily/summary`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportReport(format = "xlsx", params = {}) {
    return axios.get(`${API}reports/daily/export`, {
      params: { ...params, format },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
